import styles from "./footer.module.css";
import LogoFooter from "../../../images/_finais/logo_footer_compress.webp";
import { NavLink } from "react-router-dom";

interface IProps {
  onHandlePages: any;
}
const Footer = ({ onHandlePages }: IProps) => {
  const handleClickEmail = () => {
    window.location.href = "mailto:contato@truevidence.com.br";

    return window.location.href;
  };

  return (
    <main className={styles.footer}>
      <section className={styles.footer_section}>
        <div className={styles.container_links}>
          <h5 className={styles.links_title}>NOSSOS PRODUTOS</h5>
          <ul className={styles.link_list}>
            <NavLink
              to="/produtos/strategic-planning"
              onClick={() => onHandlePages("PRODUTOS")}
            >
              <li className={styles.link}>Strategic Planning</li>
            </NavLink>
            <NavLink
              to="/produtos/rwe-analytics"
              onClick={() => onHandlePages("PRODUTOS")}
            >
              <li className={styles.link}>RWE Analytics</li>
            </NavLink>
            <NavLink
              to="/produtos/scientific-writing-communication"
              onClick={() => onHandlePages("PRODUTOS")}
            >
              <li className={styles.link}>
                Scientific Writing & Communication
              </li>
            </NavLink>
            <NavLink
              to="/produtos/trainings-workshops"
              onClick={() => onHandlePages("PRODUTOS")}
            >
              <li className={styles.link}>Trainings & Workshops</li>
            </NavLink>
            <NavLink
              to="/produtos/masterclasses"
              onClick={() => onHandlePages("PRODUTOS")}
            >
              <li className={styles.link}>Masterclass</li>
            </NavLink>
          </ul>
        </div>
        <div className={styles.container_links}>
          <h5 className={styles.links_title}>LINKS</h5>
          <ul className={styles.link_list}>
            <NavLink to="/" onClick={() => onHandlePages("HOME")}>
              <li className={styles.link}>Home</li>
            </NavLink>
            <NavLink to="/sobre" onClick={() => onHandlePages("SOBRE")}>
              <li className={styles.link}>Sobre</li>
            </NavLink>
            <NavLink to="/produtos" onClick={() => onHandlePages("PRODUTOS")}>
              <li className={styles.link}>Produtos</li>
            </NavLink>
            <NavLink to="/equipe" onClick={() => onHandlePages("EQUIPE")}>
              <li className={styles.link}>Equipe</li>
            </NavLink>
            <NavLink to="/clientes" onClick={() => onHandlePages("CLIENTES")}>
              <li className={styles.link}>Clientes</li>
            </NavLink>
            {/* <NavLink
              to="/noticias"
              onClick={() => onHandlePages("INSIGHTS")}
            >
              <li className={styles.link}>Insights</li>
            </NavLink> */}
            <NavLink to="/contato" onClick={() => onHandlePages("CONTATO")}>
              <li className={styles.link}>Contato</li>
            </NavLink>
          </ul>
        </div>
        <div className={styles.container_links}>
          <h5 className={styles.links_title}>CONTATO</h5>
          <ul className={styles.link_list}>
            {/* <li className={styles.link}>+55 51 9 9602-0353</li> */}
            <li className={styles.link} onClick={handleClickEmail}>
              contato@truevidence.com.br
            </li>
          </ul>
        </div>
        <div className={styles.logoDiv}>
          <img
            className={styles.logoFooter}
            src={LogoFooter}
            alt="Logo TruEvclassNameence"
            loading="lazy"
          />
        </div>
      </section>
      <div className={styles.copyright}>
        <span>© 2024 TruEvidence. Todos os direitos reservados.</span>
      </div>
    </main>
  );
};

export default Footer;
